import { Box, Flex, Text } from "@chakra-ui/react";
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import config from '@config';
import ContentArea from "./ContentArea";
import { modifyDatoImgUrlToStatic } from "./utils";


let TopBannerKarma = ({ sectionContent }) => {
    return <Box
        backgroundImage={{
            base: modifyDatoImgUrlToStatic(sectionContent?.[0]?.mobileImage?.url),
            md: modifyDatoImgUrlToStatic(sectionContent?.[0]?.desktopImage?.url)
        }}
        height={{ base: '786px', md: '671px', lg: '977px', xl: '977px', '2xl': '977px' }}
        backgroundSize="cover"
        mt={'-50px'}
        pt={{ base: '30rem', md: '16rem', lg: '35rem' }}
    >
        <Box
        marginTop={{ base: '22px', md: '0px', lg: '-30px'}}
        bgGradient={'linear-gradient(180deg, rgba(3, 0, 64, 0) 0%, #030040 100%)'}
        bgBlendMode={'multiply'}
        >
            <Text
                fontFamily={'var(--AustinMedium)'}
                textAlign={'center'}
                fontSize={{ base: '64px', md: '110px' }}
                color={'#FFFFFF'}
                fontWeight={500}
                marginBottom={{base: '-12px', md: '-30px'}}
            >{sectionContent?.[0]?.title}</Text>
            <Flex justifyContent={'center'} w={'100%'} alignItems={'center'} textTransform={'uppercase'}>
                <ContentArea
                    width={'351px'}
                    // mx={'0px'}
                    tAlign={'center'}
                    // px={{ base: '20px', lg: "0px" }}
                    fontFamily={'var(--FedraSansStd-medium)'}
                    color={'#FFFFFF'}
                    mainContent={sectionContent?.[0]?.titleSubtext?.value}
                    sectionContent={sectionContent?.[0]?.titleSubtext}
                    font={{ base: '19.19px', md: '26px' }}
                    fontWeight={500}
                    lineHeight={{base: '24.48px', md: "33.18px"}}
                />
            </Flex>
            <Flex pt={{base:'5px', md: '20px', lg: '30px'}} pb={{base: '30px', md: '80px'}} justifyContent={'center'} w={'100%'} alignItems={'center'} >
                <LazyLoadImageComponent
                    src={modifyDatoImgUrlToStatic(sectionContent?.[1]?.image?.url)}
                    alt=""
                    width={{ base: '207.52px', md: "276.47px" }}
                    height="100%"
                />
            </Flex>

        </Box>
    </Box>
}

export default TopBannerKarma;